/**
 * @Description 重新发起审批弹框共通-备注输入、选择下个节点、后续节点审批人
 *   参照发起审批弹框实现
 *     src/common/components/business/ExpandStore/ApprovalCreateDialog/index.tsx
 *
 *   目前使用的场景
 */
import { FC, useRef } from 'react';
import { Form, Modal } from 'antd';
import { useMethods } from '@lhb/hook';
import V2Form from '@/common/components/Form/V2Form';
import { approvalReboot } from '@/common/api/expandStore/approveworkbench';
import V2Message from '@/common/components/Others/V2Hint/V2Message';
import { dealApprovalSumitExtras } from '@/common/components/business/ExpandStore/ApprovalSelectNodes/config';
import ApprovalSelectNodes from '@/common/components/business/ExpandStore/ApprovalSelectNodes';
import { ApprovalType, ApprovalTypeValue } from '../ts-config';
import styles from './index.module.less';

interface ApprovalRebootDialogProps {
  visible: boolean;
  setVisible: (visible: boolean) => void;
  approvalId: number;
  relationId:number; // 审批主体id
  type: ApprovalType;
  typeValue: ApprovalTypeValue;
  specialParams?: any; // 业务特有的提交审批参数（对象格式）
  onComplete?: () => void; // 提交成功
}

const ApprovalRebootDialog: FC<ApprovalRebootDialogProps> = ({
  visible,
  setVisible,
  approvalId,
  relationId,
  type,
  typeValue,
  specialParams = {},
  onComplete,
}) => {
  const isLockRef = useRef<boolean>(false);
  const [form] = Form.useForm();

  const methods = useMethods({
    handleCancel() {
      setVisible(false);
      form.resetFields();
    },
    handleOk() {
      form.validateFields().then(async (values: any) => {
        setVisible(false);
        methods.confirmDialog(values);
      });
    },
    /**
     * @description 确认提交弹框填写后提交事件
     * @param values 确认提交弹框的表单对象
     */
    async confirmDialog(values: any) {
      if (isLockRef.current) return;
      isLockRef.current = true;

      const extras: any = dealApprovalSumitExtras(values);
      const res = await approvalReboot({
        id: approvalId,
        ...specialParams,
        ...values,
        ...extras,
      }).finally(() => {
        isLockRef.current = false;
      });
      if (res) {
        V2Message.success('重新提交成功');
        methods.handleCancel();
        onComplete?.();
      }
    },
  });

  return (
    <Modal
      title='重新提交'
      open={visible}
      destroyOnClose={true}
      width={336}
      onCancel={methods.handleCancel}
      onOk={methods.handleOk}
      className={styles.rebootDialog}
    >
      <V2Form form={form}>
        <ApprovalSelectNodes
          id={relationId}
          type={type}
          typeValue={typeValue}
          isReboot={true}
          approvalId={approvalId}
        />
      </V2Form>
    </Modal>
  );
};
export default ApprovalRebootDialog;
